import { render, staticRenderFns } from "./TriggerBlockImages.vue?vue&type=template&id=dbc6c00a&scoped=true&"
import script from "./TriggerBlockImages.vue?vue&type=script&lang=ts&"
export * from "./TriggerBlockImages.vue?vue&type=script&lang=ts&"
import style0 from "./TriggerBlockImages.vue?vue&type=style&index=0&id=dbc6c00a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc6c00a",
  null
  
)

export default component.exports